import useUser from "./use-user";

export default function useIsLogged() {
    const {user} = useUser();
    return {
        isLogged: Boolean(user)
    }
}
